export { default } from './combineStringParts'
